<template>
    <div>
        <div class="col-12 clearfix mb-3">
            <button type="button" class="btn btn-brand pull-left" @click.prevent="createNew">{{ uLang('app.add_type', { type: lang('app.role') }) }}</button>
            <button type="button" class="btn btn-danger pull-right" @click.prevent="deleteCurrent"
                    :disabled="!id || !role.deletable" :title="delete_button_title">{{ uLang('app.delete_type', { type: lang('app.role') }) }}</button>
        </div>

        <div class="col-12 document-type-type-select">
            <form-select
                    name="role"
                    label="role"
                    :options="roles"
                    :allow-empty="false"
                    :on-input="onRoleSelected"
                    :loading="!roles.length"
                    track-by="id"
                    ref="roleSelect"
                    autocomplete="off"
            >
            </form-select>
        </div>

        <div class="col-12" v-if="roles.length && (id || is_new) && !retrieving">
            <form
                class="form-horizontal"
                enctype="multipart/form-data"
                @submit.prevent="store"
                @keydown="form.errors.clear($event.target.name)"
                novalidate
                autocomplete="off"
            >
                <form-input :form="form" name="name" required/>

                <table class="table custom-stripe borderless">
                    <thead>
                        <tr>
                            <th>{{ uLang('app.module') }}</th>
                            <th>{{ uLang('app.create') }}</th>
                            <th>{{ uLang('app.view') }}</th>
                            <th>{{ uLang('app.update') }}</th>
                            <th>{{ uLang('app.delete') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- <tr v-if="!modules" class="text-center">
                            <td colspan="5">
                                <i class="fa fa-3x fa-spin fa-circle-o-notch"></i>
                            </td>
                        </tr> -->
                        <tr v-for="module, key in modules">
                            <td>{{ uLang('app.' + key) }}</td>
                            <td>
                                <label v-if="form.modules[key].create" class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" v-model="form.modules[key].create.value">
                                    <span class="custom-control-indicator"></span>
                                    <span class="custom-control-description">{{ uLang('app.' + form.modules[key].create.name) }}</span>
                                </label>
                            </td>
                            <td>
                                <label v-if="form.modules[key].view" class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" v-model="form.modules[key].view.value">
                                    <span class="custom-control-indicator"></span>
                                    <span class="custom-control-description">{{ uLang('app.' + form.modules[key].view.name) }}</span>
                                </label>
                            </td>
                            <td>
                                <label v-if="form.modules[key].update" class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" v-model="form.modules[key].update.value">
                                    <span class="custom-control-indicator"></span>
                                    <span class="custom-control-description">{{ uLang('app.' + form.modules[key].update.name) }}</span>
                                </label>
                            </td>
                            <td>
                                <label v-if="form.modules[key].delete" class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" v-model="form.modules[key].delete.value">
                                    <span class="custom-control-indicator"></span>
                                    <span class="custom-control-description">{{ uLang('app.' + form.modules[key].delete.name) }}</span>
                                </label>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <rea-loader :loading="!custom"></rea-loader>

                <div v-for="module, key in custom">
                    <p><strong>{{ uLang('app.' + key) }}</strong></p>
                    <div v-for="perm, action in module">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" v-model="form.custom[key][action].value">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">{{ uLang('app.' + perm.name) }}</span>
                        </label>
                    </div>
                </div>

                <div class="form-group fr-absolute">
                    <input :disabled="form.busy" type="submit" class="btn btn-brand"
                           :value="isUpdate() ? uLang('app.save') : uLang('app.add_type', { type: lang('app.role')})"/>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import DestroyAlert from '~/Swals/DestroyAlert'
    import Form from '~/Form/Form'
    import FormMixin from '~/mixins/form'
    import { event }  from '~/events'
    import { ReaLoader } from '~/components/helpers'

    export default {
        name: 'roles',

        components: {
            ReaLoader
        },

        mixins: [
            FormMixin
        ],

        data() {
            return {
                id: null,
                entity: 'role',
                form: new Form({
                    name: '',
                    modules: [],
                    custom: [],
                }),
                roles: [],
                role: null,
                modules: null,
                custom: null,
                is_new: false,
            }
        },

        computed: {
            delete_button_title() {
                if (!(this.id || this.is_new)) {
                    return uLang('app.choose_a_type_to_delete', {type: lang('app.role')});
                } else if (this.is_new) {
                    return uLang('app.select_a_different_type_to_delete_new_type', {type: lang('app.role')});
                } else if (this.id) {
                    if (this.role.deletable) {
                        return uLang('app.delete_type', {type: lang('app.role')});
                    } else {
                        return uLang('app.this_type_isnt_deletable', {type: lang('app.role')});
                    }
                }
            },
        },

        created: function () {
            this.retrieveRoles();

            this.$on('afterStore', this.afterSave);
            this.$on('afterUpdate', this.afterSave);
        },

        methods: {
            afterSave(data) {
                this.retrieveRoles(true, data.id);
                this.retrievePermissions();
            },

            async retrieveRoles(afterSave, id) {
                let {data} = await window.axios.get(route('roles.index'));
                this.roles = data;

                let roleSelect = this.$refs.roleSelect;
                if (afterSave) {
                    roleSelect.model = this.roles.find(t => t.id === id);
                    this.onRoleSelected(roleSelect.model);
                }
            },

            async deleteCurrent() {
                new DestroyAlert({ entity: this.lang('app.role') }).show().then(async () => {
                    let response = await window.axios.delete(route('roles.destroy', { role: this.id }));

                    await this.clearForm();

                    this.retrieveRoles();
                });
            },

            async createNew() {
                // Show form for when item is new
                this.is_new = true;

                await this.clearForm();

                this.retrievePermissions();
            },

            async clearForm() {
                // Set selected role to null
                this.$refs.roleSelect.model = null;

                // Reset the data
                this.id = null;
                this.role = null;
                this.form.name = '';
                this.form.description = '';
                this.form.roles = null;
                this.modules = null;
                this.custom = null;
            },

            async onRoleSelected(val) {
                this.is_new  = false;
                this.modules = null;
                this.custom = null;

                if (val !== null) {
                    this.id = val.id;
                    this.role = val;
                    await this.retrieve();
                    await this.retrievePermissions();
                } else {
                    this.role = null;
                }
            },

            resolveRoute() {
                if(this.isUpdate()) {
                    return '/api/admin/roles/' + this.id + '/edit';
                }

                return '/api/admin/roles/create';
            },

            async retrievePermissions() {
                const { data } = await window.axios.get(this.resolveRoute());

                this.modules = data.is_crud;
                this.form.modules = this.modules;
                this.form.originalData.modules = this.modules;

                this.custom = data.custom;
                this.form.custom = this.custom;
                this.form.originalData.custom = this.custom;
            },
        }
    }
</script>

<style lang="scss" scoped>
    table{
        .custom-control.custom-checkbox{
            margin: 0;
        }
    }
</style>